export default __webpack_public_path__ + "static/media/46.1e52ace2.jpg";